"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("../../../utils");
var _Button = _interopRequireDefault(require("./Button"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
/* eslint-disable no-restricted-globals */

class ButtonSegment extends _Button.default {
  constructor(opts) {
    if (opts.value === 'all') {
      opts.multiselect = false;
    } else if (!(0, _utils.isset)(opts.multiselect)) {
      opts.multiselect = true;
    }
    super(opts);
  }
  get key() {
    return `${this.parentId ? `${this.parentId}::` : ''}${this.groupId ? `${this.groupId}::` : ''}${this.id}`;
  }
  get multiselect() {
    return this.opts.multiselect;
  }
  _render(data) {
    return `
			<li>${this.title}</li>
		`;
  }
}
var _default = exports.default = ButtonSegment;
module.exports = exports.default;